<template>
  <div>
    <!-- 关联订单 -->
    <el-dialog
      title="关联订单"
      width="1200px"
      top="2vh"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-button type="primary" size="small" @click="handleDownload">导出当前数据</el-button>
      <el-table
        v-loading="loading"
        :data="data"
        style="width:100%;margin-top:10px"
        border
      >
        <el-table-column label="班级名称" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.skuName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单号" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.orderNumber || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属教务服务方" minWidth="190" align="center">
          <template>
            <span>{{ agentName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="$myStore.state.user.userIdentity !== 2" label="所属招生服务方" minWidth="190" align="center">
          <template>
            <span>{{ distributionName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单类别" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.orderSource === 1">普通订单</el-tag>
            <el-tag size="small" type="success" v-else-if="row.orderSource === 2">团购订单</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="用户昵称" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.nickname || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="身份证号" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.idCard || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学员姓名" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" minWidth="160" align="center">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="分账中心订单号" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.payOrderNo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付类型" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.payType === 'YPL'">易票联</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="支付状态" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.payStatus === 1">未支付</el-tag>
            <el-tag size="small" v-else-if="row.payStatus === 2" type="success">已支付</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="签约是否超过3天" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.isFifteen === 1">是</el-tag>
            <el-tag size="small" v-else-if="row.isFifteen === 2" type="success">否</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="清分状态" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.payStatus === 1">未支付</el-tag>
            <el-tag size="small" v-else-if="row.payStatus === 2" type="success">已支付</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column> -->
        <el-table-column label="结算状态" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.isBalance === 1">未结算</el-tag>
            <el-tag size="small" v-else-if="row.isBalance === 2" type="success">结算中</el-tag>
            <el-tag size="small" v-else-if="row.isBalance === 3" type="success">已结算</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.orderState === 1">待支付</el-tag>
            <el-tag size="small" v-else-if="row.orderState === 2" type="success">待签约</el-tag>
            <el-tag size="small" v-else-if="row.orderState === 3">待评价</el-tag>
            <el-tag size="small" v-else-if="row.orderState === 4" type="warning">订单完成</el-tag>
            <el-tag size="small" v-else-if="row.orderState === 5" type="info">订单关闭</el-tag>
            <el-tag size="small" v-else-if="row.orderState === 6" type="info">订单取消</el-tag>
            <el-tag size="small" v-else-if="row.orderState === 7" type="danger">已退款</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column v-if="filter.id" label="是否通过验收标准" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.passStatus === 1" type="danger">否</el-tag>
            <el-tag size="small" v-else-if="row.passStatus === 2" type="success">是，考试通过</el-tag>
            <el-tag size="small" v-else-if="row.passStatus === 3" type="info">是，考试权益已使用</el-tag>
            <el-tag size="small" v-else-if="row.passStatus === 4" type="warning">是，服务期结束</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.payTime || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.payAmt || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单来源" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.sourceType === 1">PC</el-tag>
            <el-tag size="small" v-else-if="row.sourceType === 2" type="success">小程序</el-tag>
            <el-tag size="small" v-else-if="row.sourceType === 3" type="info">安卓</el-tag>
            <el-tag size="small" v-else-if="row.sourceType === 4" type="danger">ios</el-tag>
            <el-tag size="small" v-else-if="row.sourceType === 5" type="warning">H5</el-tag>
            <el-tag size="small" v-else-if="row.sourceType === 6" type="warning">后台</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="退款状态" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.refundStatus === 1">未退款</el-tag>
            <el-tag size="small" v-else-if="row.refundStatus === 2" type="info">退款中</el-tag>
            <el-tag size="small" v-else-if="row.refundStatus === 3" type="success">已退款</el-tag>
            <el-tag size="small" v-else-if="row.refundStatus === 4" type="danger">打款失败</el-tag>
            <el-tag size="small" v-else-if="row.refundStatus === 5" type="warning">已驳回</el-tag>
            <el-tag size="small" v-else-if="row.refundStatus === 6" type="info">已取消退费</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="是否签约" minWidth="140" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.signType === 1">未签约</el-tag>
            <el-tag size="small" v-else-if="row.signType === 2" type="success">签约</el-tag>
            <el-tag size="small" v-else-if="row.signType === 3" type="info">没有合同</el-tag>
            <el-tag size="small" v-else-if="row.signType === 4" type="danger">协议签约中</el-tag>
            <el-tag size="small" v-else-if="row.signType === 5" type="warning">暂不用签约</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.auditStatus === 1">审核中</el-tag>
            <el-tag size="small" v-else-if="row.auditStatus === 2" type="success">审核通过</el-tag>
            <el-tag size="small" v-else-if="row.auditStatus === 3" type="danger">驳回</el-tag>
            <el-tag size="small" v-else-if="row.auditStatus === 9" type="warning">不需要审核</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="是否提交发票信息" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" type="info" v-if="row.invoiceApplyStatus === 1">否</el-tag>
            <el-tag size="small" type="success" v-else-if="row.invoiceApplyStatus === 2">是</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-dialog>
    <file-export ref="FileExport"></file-export>
  </div>
</template>

<script>
import { pageByBill } from "@/api/orderAdmin/orderList"
import { getAppUserInfo } from "@/api/common"
import FileExport from "@/components/FileExport.vue";
import myPagination from "@/components/myPagination.vue"

export default {
  name: 'RelevantList',

  components: { FileExport, myPagination },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      isByOrder: false,
      receiptId: '',
      filter: {
        balanceId: '',
      },
      agentName: '',
      distributionName: '',
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
    }
  },
  methods: {
    init (payload) {
      if (payload.receiptId) {
        this.filter.id = payload.receiptId
      }
      if (payload.isByOrder) {
        this.isByOrder = payload.isByOrder
      }
      this.filter.balanceId = payload.id
      this.agentName = payload.agentName
      this.distributionName = payload.distributionName
      this.getOrderListPage({
        ...this.filter,
        ...this.pageInfo,
        isByOrder: payload.isByOrder
      })
      this.dialogVisible = true
    },
    // 列表请求
    getOrderListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page
      this.pageInfo.limit = payload.limit
      pageByBill(payload).then(({ code, data }) => {
        if (code === 0) {
          this.data = data.records
          this.pageInfo.total = Number(data.total)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getOrderListPage({
        ...this.filter,
        page: payload,
        limit: this.pageInfo.limit
      })
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getOrderListPage({
        ...this.filter,
        page: 1, limit: payload
      })
    },
    handleClose () {
      this.filter = this.$options.data().filter
      this.pageInfo = this.$options.data().pageInfo
      this.data = []
      this.dialogVisible = false
    },
    async handleDownload () {
      const params = {
        balanceId: this.filter.balanceId
      }
      if (this.filter.id) {
        params.id = this.filter.id
      }
      this.$refs.FileExport.init(
        params,
        'jsw-order-provider',
        '/adm/bill/downBillOrder',
        1,
        `关联订单列表-${Date.parse(new Date())}.xlsx`
      )
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.userId }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.data.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  }
}
</script>

<style>

</style>
